import axios from 'axios';
import REACT_APP_BACK_URL from '../../constants/constants';

export const getLinkFavorites = async ({ workspaceName }) => axios
  .get(`${REACT_APP_BACK_URL}/${workspaceName}/linkFavorites`);

export const addLinkFavorite = async ({ workspaceName, url, label }) => axios
  .post(
    `${REACT_APP_BACK_URL}/${workspaceName}/linkFavorites`,
    { url, label },
  );

export const removeLinkFavorite = async ({ workspaceName, url }) => axios
  .delete(
    `${REACT_APP_BACK_URL}/${workspaceName}/linkFavorites`,
    { data: { url } },
  );

export const getLinkVisits = async ({ workspaceName, limit }) => axios
  .get(`${REACT_APP_BACK_URL}/${workspaceName}/linkVisits${limit ? `?limit=${limit}` : ''}`);

export const recordLinkVisit = async ({ workspaceName, url, label }) => axios
  .post(
    `${REACT_APP_BACK_URL}/${workspaceName}/linkVisits`,
    { url, label },
  );

export const clearLinkVisits = async ({ workspaceName }) => axios
  .delete(`${REACT_APP_BACK_URL}/${workspaceName}/linkVisits`);
